import { Dayjs } from "dayjs";

// Validation function for date range
export const validateDateRange = (
  start: Dayjs | null,
  end: Dayjs | null,
): string | null => {
  if (!start || !end) {
    return "Please select both start and end date/time";
  }

  if (start.isAfter(end)) {
    return "Start date/time must be before end date/time";
  }

  return null;
};
